import styled from "@emotion/styled";
import { Container, Grid } from "@mui/material";
import React from "react";
import SectionsHeading from "../../SectionsHeading";
import { Div, Image } from "../../../../Styles/style";
import trustwallet from "../../../../../assets/Images/trustwallet.png";
import dextools from "../../../../../assets/Images/dextools.png";
import dexscrener from "../../../../../assets/Images/dexscrener.png";
import uniswap from "../../../../../assets/Images/uniswap.png";
import etherscan from "../../../../../assets/Images/etherscan.png";
import div1bg from "../../../../../assets/Images/div1bg.png";
import div2bg from "../../../../../assets/Images/div2bg.png";
import Paragraph from "../../Paragraph";
import CustomButton from "../../CustomBtn";
const ContinerWraper = styled(Container)`
  background: ${(props) => props.theme.bgPrimary};
  width: 100%;
  border-radius: 20px;
  padding-top: 20px;
  padding-bottom: 20px;
  margin-top: 20px;
`;
const InnerGrid = styled(Grid)`
  background: ${(props) => props.theme.bgPrimary};
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: start;
  width: 100%;
  border-radius: 20px;
  padding: 10px 10px 80px 10px;
  margin: 10px 0;
  ::after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-image: url(${(props) => props.bg});
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    filter: grayscale(100%);
    border-radius: 20px;
  }
`;
const InnerDiv = styled.div`
  background-color: ${(props) => props.bgPrimary};
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: start;
  width: 100%;
  border-radius: 20px;
  padding: 10px;
`;
const ImageGrid = styled(Grid)`
  display: flex;
  justify-content: end;
  align-items: center;
  @media (max-width: 899px) {
    flex-direction: column;
  }
`;

const StatsSection = () => {
  return (
    <Container
      maxWidth="xxl"
      sx={{
        p: "0 !important",
      }}
    >
      <ContinerWraper>
        <Grid container>
          <Grid
            item
            xs={12}
            md={1}
            sx={{ display: "flex", justifyContent: "center" }}
          >
            <SectionsHeading p599="0px 0 20px" ta="left" fs="16px" fs599="18px">
              Our Partners
            </SectionsHeading>
          </Grid>
          <ImageGrid item xs={12} md={11}>
            <Div
              fd899="column"
              style={{ justifyContent: "space-between", width: "80%" }}
            >
              <Image mw="120px" src={trustwallet} />
              <Image mw="120px" src={dextools} />
              <Image mw="120px" src={dexscrener} />
              <Image mw="120px" src={uniswap} />
              <Image mw="120px" src={etherscan} />
            </Div>
          </ImageGrid>
        </Grid>
      </ContinerWraper>

      <Container sx={{ mt: "70px", padding: "0 !important" }} id="stats">
        <Grid
          container
          sx={{
            columnGap: "20px",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <InnerGrid bg={div1bg} item xs={12} sm={5.7}>
            <InnerDiv>
              <SectionsHeading
                ta="left"
                fs="16px"
                fs599="16px"
                color="#FC9C00 !important"
              >
                Total $SHIA Collatral
              </SectionsHeading>
              <SectionsHeading ta="left" fs="28px" fs599="28px" fm="PoppinsR">
                Loading...
              </SectionsHeading>
            </InnerDiv>
          </InnerGrid>
          <InnerGrid bg={div2bg} item xs={12} sm={5.7}>
            <InnerDiv>
              <SectionsHeading
                ta="left"
                fs="16px"
                fs599="16px"
                color="#FC9C00 !important"
              >
                Total $ETH Borrowed
              </SectionsHeading>
              <SectionsHeading ta="left" fs="28px" fs599="28px" fm="PoppinsR">
                Loading...
              </SectionsHeading>
            </InnerDiv>
          </InnerGrid>
        </Grid>
      </Container>

      <ContinerWraper
        sx={{
          mt: "50px !important",
          pt: "50px !important",
          pb: "50px !important",
        }}
      >
        <Grid container sx={{ display: "flex", justifyContent: "center" }}>
          <Grid item xs={12} sx={{ display: "flex", justifyContent: "center" }}>
            <SectionsHeading fs="42px" fs599="42px" color="#FC9C00 !important">
            Yep, 0% Interest. Really.
            </SectionsHeading>
          </Grid>
          <Grid
            item
            xs={11}
            sm={10}
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Paragraph fs="14px" p="30px 0">
              One of the standout features of the Shia Vault protocol is its
              unique approach to lending that sets it apart from traditional
              financial systems. Unlike conventional loans that typically
              involve interest charges, Shia Vault operates with a refreshing 0%
              interest model. This means that users who leverage their Shia
              tokens as collateral to obtain Ethereum tokens won't have to worry
              about accruing interest payments over time. Instead, they only
              incur a one-time flat fee at the moment of collateral locking.
            </Paragraph>
          </Grid>
          <Grid
            item
            xs={12}
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <CustomButton
              bgc="transparent"
              c="#fff"
              hbgc="#fff"
              hc="#000"
              b="1px solid #fff"
            >
              Open Vault
            </CustomButton>
          </Grid>
        </Grid>
      </ContinerWraper>
    </Container>
  );
};

export default StatsSection;
